// extracted by mini-css-extract-plugin
export default {"container":"Scrollable_container__F7bLV","content":"Scrollable_content__Z-hc+"};